import api from "./api";

export default class MainApi {
  static async Get(data) {
    return await api.get(`visitor`, data);
  }
}
